import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "../../utils/ScrooltoTop";
import Chat from "./Chat";
import ChatIcon from "../../icons/ChatIcon";
import { httpReauest } from "../../utils/httpRequest";
import { PiChatsCircleDuotone } from "react-icons/pi";

const Layout = ({ children }) => {
  const [chat, setchat] = useState();

  const [data, setData] = useState();

  useEffect(() => {
    getData();
  }, []);


  async function getData(params) {
    await httpReauest("GET", `/data`, {}, {}).then(({ data }) => {
      setData(data?.data[0]);
    });
  }

  const childrenWithProps = React.Children.map(children, (child) => {
    // Checking isValidElement is the safe way and avoids a
    // typescript error too.
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { dealerData: data, setchat });
    }
    return child;
  });
  return (
    <>
      <div
        dir="rtl"
        className="w-full flex flex-col  m-0 justify-center items-center p-2"
      >
        {chat ? (
          <Chat
            welcomeText={data?.welcomeText}
            onClose={() => setchat(false)}
          />
        ) : (
          <button
            onClick={() => setchat(true)}
            className="bg-black rounded-full p-2  fixed right-5 bottom-5 w-[70px] h-[70px] flex justify-center items-center z-40"
          >
            <span className="scale-150">
              <PiChatsCircleDuotone size={25} color="#FFA800"/>
            </span>
          </button>
        )}

        <ScrollToTop />
        <Header dealerData={data}/>
        {childrenWithProps}
        <Footer dealerData={data} />
      </div>
    </>
  );
};

export default Layout;
